module.exports = __webpack_public_path__ + "img/article_placeholder--basic.c0a9a81.png";